export const FEATURED = 'featured';
export const HIGH_TO_LOW = 'price-desc';
export const LOW_TO_HIGH = 'price-asc';

const sortOptionDetails = {
  [FEATURED]: {
    label: 'Featured',
    value: {
      property: 'retailerSortOrder',
      direction: 'asc',
    },
  },
  [HIGH_TO_LOW]: {
    label: 'Price high to low',
    value: {
      property: 'priceCents',
      direction: 'desc',
    },
  },
  [LOW_TO_HIGH]: {
    label: 'Price low to high',
    value: {
      property: 'priceCents',
      direction: 'asc',
    },
  },
};

export const getSortOptionDetails = option => sortOptionDetails[option];
